import {
  createActionTypes,
  createAsyncActionTypes,
} from "@dpdgroupuk/redux-action-creator";

export default createActionTypes("DASHBOARD", {
  GET_RETURNS_DASHBOARD: createAsyncActionTypes("GET_RETURNS_DASHBOARD"),
  RESET_DASHBOARD: "RESET_DASHBOARD",
});
